import React, { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import InterestDropDown from "./DropDowns/InterestDropDown";

export default function Goals({ initial = {}, saveProfile }) {
  const [data, setData] = useState({
    goals:       initial?.goals || "",
    lookingFor:  initial?.lookingFor || "",
  });
  const [interest, setInterest] = useState(initial?.interest || []);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) =>
    setData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    await saveProfile({
      goalsAndInterests: { ...data, interest },
    });
    setSaving(false);
  };

  return (
    <>
      <Backdrop open={saving} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={onSave}>
        <div><h3>Goals</h3></div>

        <div className={Classes.infoConMiddle}>
          {[
            ["goals", "What are Your Goals?", "Start a business, break into product design..."],
            ["lookingFor", "What are You Looking For In a Mentor?", "Career advice, skill feedback..."],
          ].map(([key, label, ph]) => (
            <div key={key} className={Classes.flexColGroup}>
              <div className={Classes.flexCol1}>
                <h5 className={Classes.label}>{label}</h5>
                <input
                  name={key}
                  className={Classes.inputField}
                  placeholder={ph}
                  value={data[key]}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          ))}

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Areas of Interest</h5>
              <InterestDropDown selected={interest} onChange={setInterest} />
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
